export default __webpack_public_path__ + "static/media/AI_process.61cb6265.png";